import React from 'react';

const getLXPType = isVirtual => {
  return isVirtual ? 'zoom' : 'in-person';
};

export default getLXPType;
